import { MemreButton, MemreContainer, MemreFlexBox, MemreInput, MemreSectionHeading, MemreText } from 'components/core';

import { createElement, useMemo, useState } from 'react';
import { createImage } from 'utils/createImage';
import getFileFromUrl from 'utils/getFileFromUrl';
import { updateImage } from 'utils/updateImage';
import DragNDrop from './DragNDrop';
import ImageByUrl from './ImageByUrl';

const tabs = {
  'Upload Image': DragNDrop,
  'Add via URL': ImageByUrl,
};

export default function ImageUploadModal({ addImageMethod, close }) {
  const tabNames = Object.keys(tabs);
  const [selectedTab, setSelectedTab] = useState(tabNames[0]);
  const [selectedImage, setSelectedImage] = useState<string | File | null>(null);

  const [altText, setAltText] = useState('');
  const [source, setSource] = useState('');

  const handleUploadImage = async () => {
    if (!selectedImage) {
      return;
    }
    const isUrl = typeof selectedImage === 'string';
    const file = isUrl ? await getFileFromUrl(selectedImage as string) : selectedImage;
    const image = await createImage(file as File);

    const updatedImage = await updateImage({
      id: image.id,
      payload: {
        data: {
          attributes: {
            'alt-tag': altText,
            url: source,
          },
        },
      },
    });
    addImageMethod(updatedImage.url, updatedImage.id);
    close();
  };

  const handleTabChange = (e: number) => {
    setSelectedImage(null);

    const newTab = Object.keys(tabs)[e];
    setSelectedTab(newTab);
  };

  const memoizedTabComponent = useMemo(() => {
    return createElement(tabs[selectedTab], {
      selectedImage,
      setSelectedImage,
    });
  }, [selectedTab, selectedImage, setSelectedImage]);

  return (
    <MemreFlexBox direction="column">
      <MemreSectionHeading text={tabNames} onChange={handleTabChange} />
      <MemreContainer size="large" sx={{ height: '400px', width: '600px' }}>
        {memoizedTabComponent}
      </MemreContainer>
      {selectedImage && (
        <MemreFlexBox sx={{ p: 2, pt: 0 }} gap={2}>
          <MemreInput label="Alt Text" onValueChange={setAltText} />
          <MemreInput label="Source" onValueChange={setSource} />
        </MemreFlexBox>
      )}
      <MemreButton onClick={handleUploadImage} disabled={!selectedImage} text="Insert Image" sx={{ m: 2, mt: 0 }} />
    </MemreFlexBox>
  );
}
